import React, { useState } from "react";
import { config } from "../config/config";
import ResultadoActividadForm from "../components/ResultadoActividadForm";
import ResultadoActividadList from "../components/ResultadoActividadList";
import showAlert from "../components/Alert";
import showConfirm from "../components/ConfirmAlert";

const ResultadosActividades = () => {
    const [editingResultado, setEditingResultado] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false);
    const [resetForm, setResetForm] = useState(false);

    // Función para recargar la lista de resultados
    const reloadResultadosList = () => {
        setReloadTrigger(!reloadTrigger);
    };

    // Función para crear o actualizar un resultado
    const handleCreateOrUpdate = (resultado) => {
        const url = editingResultado
            ? `${config.apiUrl}/resultadosActividades/${editingResultado.resultado_id}`
            : `${config.apiUrl}/resultadosActividades`;
        const method = editingResultado ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(resultado),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error al guardar la información");
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingResultado);
                setEditingResultado(null);
                setResetForm(true);
                reloadResultadosList();
            })
            .catch(console.error);
    };

    // Función para eliminar un resultado
    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/resultadosActividades/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Resultado eliminado");
                    reloadResultadosList();
                })
                .catch(console.error);
        }
    };

    return (
        <div>
            <ResultadoActividadForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingResultado}
                resetForm={resetForm}
            />
            <ResultadoActividadList
                onEdit={(resultado) => setEditingResultado(resultado)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger}
            />
        </div>
    );
};

export default ResultadosActividades;